import { Component, ojs, app } from "modular-openscriptjs";
import GlobalModal from "../GlobalModal";
import OffCanvasNav from "../OffCanvasNav";
import ProfileCanvas from "./ProfileCanvas";
import { gc, uc } from "../../ojs.contexts";
import DepositCapaForm from "../Forms/DepositCapaForm";
// import TransferCapaForm from "../Forms/TransferCapaForm";
import WithdrawCapaForm from "../Forms/WithdrawCapaForm";
import ProcessOrderForm from "../Forms/ProcessOrderForm";
import PaymentRequestForm from "../Forms/PaymentRequestForm";
import PurchaseForm from "../Forms/PurchaseForm";
import AddressPicker from "../Modals/AddressPicker";
import Confirmation from "../Confirmation";
import PurchasesView from "../Modals/PurchaseView";
import TransferCapaForm from "../Forms/TransferCapaForm";
import TermsAndConditionsForm from "../Forms/TermsAndConditionsForm";
import AppReviewPromptModal from "../Modals/AppReviewPromptModal";
import FeatureAnnouncementModal from "../Modals/FeatureAnnouncementModal";

const h = app("h");

ojs(
    OffCanvasNav,
    GlobalModal,
    ProfileCanvas,
    DepositCapaForm,
    // TransferCapaForm,
    WithdrawCapaForm,
    OffCanvasNav,
    GlobalModal,
    ProfileCanvas,
    ProcessOrderForm,
    PaymentRequestForm,
    PurchaseForm,
    AddressPicker,
    Confirmation,
    PurchasesView,
    DepositCapaForm,
    TransferCapaForm,
    WithdrawCapaForm,
    TermsAndConditionsForm,
    AppReviewPromptModal,
    FeatureAnnouncementModal,
);

export default class AppOffCanvas extends Component {
    render(...args) {
        return h.wrapper(
            h.GlobalModal(),
            h.ProfileCanvas(),

            h.OffCanvasNav(gc.auth, uc.permissions, uc.roles),
            h.ReferFriend(),
            h.ProcessOrderForm(null),
            h.PaymentRequestForm(null),
            h.PurchaseForm(),
            h.AddressPicker(),
            h.Confirmation(),
            h.PurchasesView(),
            h.DepositCapaForm(),
            h.TransferCapaForm(),
            h.WithdrawCapaForm(),
            h.TermsAndConditionsForm(),
            h.AppReviewPromptModal(),
            h.FeatureAnnouncementModal(),
        );
    }

    cleanUp() {
        super.cleanUp();
        let markup = this.markup();

        for (let elem of markup) {
            disposeBootstrapTree(elem);
        }
    }
}
